import type { PropsWithChildren } from 'react';

export const HeaderSmall = ({ children }: PropsWithChildren) => (
  <h6 className="mb-md text-headline-sm font-semibold leading-tight">
    {children}
  </h6>
);

HeaderSmall.displayName = 'HeaderSmall';
